module.exports = __webpack_public_path__ + "static/media/Декларация_ОК_Н. Шемширова.0a26f6dd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Декларация_ОК_Н. Шемширова.pdf
// module id = 122
// module chunks = 0